(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeEthnicityController', TypeEthnicityController);

    TypeEthnicityController.$inject = ['GenericEntityDatatableService', 'TypeEthnicity', 'CoreService', '$uibModal',
        'ConfirmationService', '$q'];

    function TypeEthnicityController(GenericEntityDatatableService, TypeEthnicity, CoreService, $uibModal,
                                     ConfirmationService, $q) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Ethnicity Types',
            newButtonTitle: 'New Ethnicity Type',
            entityClassHumanized: 'Ethnicity Type',
            entityStateName: 'type-ethnicity',
            service: TypeEthnicity,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: 'code',
                    title: 'Code',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Ethnicity Type',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ]
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/type-ethnicity/update/type-ethnicity-dialog.html',
                controller: 'TypeEthnicityDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/type-ethnicity/update/type-ethnicity-dialog.html',
                controller: 'TypeEthnicityDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TypeEthnicity', function (TypeEthnicity) {
                        return TypeEthnicity.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Ethnicity Type').result.then(function () {
                    TypeEthnicity.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
